export const DeleteIcon = ({
  fill = "currentColor",
  filled,
  size,
  height,
  width,
  label,
  ...props
}) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="20pt"
      height="20pt"
      viewBox="0 0 946.000000 1280.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <metadata>
        Created by potrace 1.15, written by Peter Selinger 2001-2017
      </metadata>
      <g
        transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
        fill="#b71c1c"
        stroke="none"
      >
        <path
          d="M4645 12791 c-95 -11 -300 -57 -355 -81 -25 -10 -58 -21 -75 -25 -28
-6 -94 -29 -177 -63 -20 -8 -47 -26 -60 -39 -13 -14 -54 -41 -93 -60 -55 -28
-98 -63 -203 -167 -149 -146 -210 -227 -300 -397 -85 -160 -121 -303 -124
-490 -2 -128 -1 -137 26 -191 36 -76 98 -129 178 -154 96 -29 162 -23 248 22
121 63 144 106 179 330 17 109 27 145 65 225 38 79 58 108 133 184 83 84 97
95 234 163 163 82 267 109 455 119 148 8 390 -41 494 -100 19 -11 64 -36 100
-56 80 -44 207 -164 260 -245 63 -96 120 -291 120 -411 0 -47 59 -146 109
-183 126 -93 279 -87 407 16 113 91 128 195 73 492 -21 110 -68 243 -101 285
-10 13 -27 44 -38 68 -62 139 -185 278 -370 416 -167 125 -305 206 -382 226
-131 35 -199 55 -220 66 -72 39 -418 68 -583 50z"
        />
        <path
          d="M2385 12294 c-88 -13 -217 -28 -287 -34 -79 -6 -146 -17 -175 -29
-27 -10 -86 -26 -132 -36 -142 -29 -383 -117 -449 -164 -17 -11 -35 -21 -42
-21 -13 0 -91 -51 -136 -90 -17 -14 -79 -53 -138 -85 -83 -46 -122 -74 -175
-130 -73 -77 -81 -97 -81 -204 0 -71 46 -165 109 -224 49 -46 166 -95 197 -83
8 3 45 10 81 16 54 9 83 22 178 83 141 89 171 108 207 129 16 9 37 23 47 32
10 9 23 16 31 16 7 0 40 13 74 29 33 16 84 35 111 42 28 6 62 18 77 26 57 28
311 70 753 124 211 25 252 41 315 121 48 60 69 105 80 173 7 43 4 60 -21 125
-34 86 -91 148 -174 186 -44 21 -64 24 -170 23 -71 -1 -186 -11 -280 -25z"
        />
        <path
          d="M6795 12241 c-65 -29 -148 -111 -168 -167 -28 -81 -33 -164 -11 -224
26 -72 107 -160 170 -183 27 -10 143 -29 259 -42 366 -43 599 -82 710 -119 39
-13 99 -32 134 -42 62 -17 193 -87 237 -126 11 -10 25 -18 30 -18 5 0 45 -25
89 -56 111 -77 157 -99 252 -118 l81 -17 79 30 c97 38 132 72 173 170 68 166
14 303 -161 408 -44 26 -110 69 -147 96 -37 26 -70 47 -75 47 -5 0 -27 13 -50
29 -53 35 -282 147 -322 157 -16 4 -46 15 -65 24 -20 10 -83 28 -140 40 -58
12 -132 31 -165 41 -81 25 -299 59 -382 59 -38 0 -113 7 -168 15 -142 21 -309
19 -360 -4z"
        />
        <path
          d="M185 11106 c-28 -13 -63 -37 -77 -54 -37 -44 -74 -127 -86 -192 -6
-33 -13 -386 -17 -891 -7 -951 -12 -884 78 -965 89 -80 141 -104 224 -104 42
0 90 7 115 16 54 20 129 100 166 174 l27 55 9 873 c7 681 6 882 -3 914 -15 48
-94 136 -157 173 -37 22 -54 25 -136 25 -76 0 -102 -4 -143 -24z"
        />
        <path
          d="M9105 10914 c-133 -33 -210 -92 -252 -194 -17 -42 -18 -93 -18 -880
l0 -835 27 -55 c15 -30 33 -62 40 -71 23 -27 94 -67 159 -89 145 -49 304 23
372 168 l22 47 0 830 c0 805 -1 832 -20 885 -26 73 -102 149 -170 172 -56 19
-130 29 -160 22z"
        />
        <path
          d="M1389 10791 c-74 -15 -147 -88 -187 -190 -28 -72 -29 -75 -16 -150
29 -170 96 -224 404 -325 254 -84 586 -174 686 -186 43 -5 104 -16 134 -25 30
-8 75 -15 100 -15 25 0 92 -11 150 -25 58 -14 126 -25 152 -25 26 0 77 -6 115
-14 37 -8 118 -17 178 -21 61 -3 133 -11 160 -16 134 -25 1017 -48 1175 -30
111 13 817 34 1135 33 338 0 1001 -20 1090 -33 96 -13 316 -7 505 14 145 16
199 27 270 56 81 33 154 60 185 67 17 4 48 19 70 34 22 15 90 56 150 91 76 44
132 86 182 135 85 85 98 119 90 242 -7 116 -41 182 -121 236 -56 38 -64 40
-148 44 -127 6 -205 -24 -349 -134 -31 -24 -71 -50 -90 -58 -115 -49 -215 -80
-289 -90 -109 -14 -483 -13 -820 3 -315 15 -1595 8 -1700 -9 -42 -7 -220 -9
-495 -7 -531 5 -820 21 -1045 59 -36 6 -99 14 -140 18 -167 17 -263 33 -513
91 -71 16 -142 29 -160 29 -39 0 -331 84 -502 145 -71 25 -148 50 -170 55 -46
11 -134 11 -186 1z"
        />
        <path
          d="M1304 9797 c-67 -23 -104 -49 -138 -102 -60 -90 -61 -94 -61 -205 0
-96 2 -109 27 -150 56 -96 185 -160 472 -235 144 -38 188 -51 226 -68 45 -20
286 -77 326 -77 29 0 274 -49 359 -72 22 -5 78 -14 125 -18 47 -5 115 -13 153
-19 37 -6 97 -16 135 -21 37 -6 139 -18 227 -26 88 -8 228 -21 310 -29 83 -9
258 -20 390 -25 132 -6 290 -15 350 -21 71 -7 412 -9 960 -6 879 4 1474 18
1605 36 41 6 125 15 185 21 210 20 314 39 471 86 44 13 92 24 107 24 15 0 44
7 65 16 20 9 75 29 121 45 46 16 94 35 106 43 12 8 47 22 78 31 33 9 81 36
119 64 52 40 71 62 97 116 32 64 33 72 28 151 -7 125 -54 193 -172 250 -119
58 -184 49 -486 -69 -63 -25 -139 -48 -169 -52 -30 -4 -66 -12 -80 -18 -60
-24 -272 -55 -465 -67 -88 -6 -185 -15 -215 -21 -80 -16 -2152 -24 -2470 -10
-321 15 -555 28 -605 36 -22 3 -107 12 -190 20 -153 15 -258 28 -375 46 -36 6
-103 14 -150 19 -47 5 -101 14 -120 20 -19 5 -53 10 -76 10 -88 0 -858 188
-927 226 -85 47 -270 74 -343 51z"
        />
        <path
          d="M775 8683 c-87 -19 -190 -100 -226 -178 -18 -39 -19 -137 -19 -3158
0 -2641 2 -3123 14 -3150 17 -40 131 -152 169 -166 37 -14 207 -14 244 0 38
14 151 126 169 168 12 29 14 468 14 3150 0 3019 -1 3117 -19 3156 -29 63 -117
142 -184 165 -53 19 -115 24 -162 13z"
        />
        <path
          d="M2180 8635 c-25 -7 -56 -17 -70 -23 -42 -16 -132 -104 -151 -147 -18
-38 -19 -165 -19 -3298 0 -2914 2 -3262 15 -3295 25 -58 130 -159 188 -178 64
-21 187 -15 242 12 50 24 126 119 151 187 18 51 19 139 22 3232 2 2203 -1
3199 -8 3242 -15 87 -42 145 -90 192 -69 67 -194 101 -280 76z"
        />
        <path
          d="M8575 8550 c-106 -22 -167 -69 -216 -167 l-34 -68 0 -3080 0 -3080
28 -57 c54 -110 143 -163 277 -163 71 0 94 4 141 26 71 34 123 87 151 158 l23
56 3 3030 c2 2086 -1 3045 -8 3079 -17 80 -69 175 -113 207 -67 49 -177 74
-252 59z"
        />
        <path
          d="M6994 8321 c-130 -33 -210 -124 -234 -262 -8 -45 -10 -944 -8 -3099
l3 -3035 23 -57 c28 -68 110 -163 160 -183 46 -20 198 -20 243 -1 44 19 162
141 180 186 12 30 14 500 14 3130 0 3021 0 3096 -19 3143 -47 120 -234 211
-362 178z"
        />
        <path
          d="M3670 8244 c-90 -24 -139 -60 -192 -144 l-47 -75 0 -3255 -1 -3255
36 -55 c51 -78 102 -129 152 -151 60 -26 184 -26 244 0 59 26 151 124 174 186
18 48 19 147 19 3280 l0 3230 -23 49 c-68 146 -220 226 -362 190z"
        />
        <path
          d="M5284 8231 c-18 -4 -61 -24 -97 -44 -60 -34 -67 -42 -103 -114 l-39
-78 0 -3270 0 -3270 40 -80 c37 -75 44 -82 105 -117 111 -64 209 -67 320 -10
65 33 110 94 140 191 20 62 20 104 20 3280 0 2131 -4 3231 -11 3260 -13 58
-57 146 -88 178 -58 58 -204 96 -287 74z"
        />
        <path
          d="M8793 1631 c-97 -24 -183 -92 -248 -196 -11 -18 -58 -68 -105 -112
-64 -60 -110 -93 -184 -132 -55 -28 -104 -51 -109 -51 -6 0 -35 -12 -66 -26
-31 -14 -74 -35 -96 -45 -22 -10 -93 -32 -158 -49 -65 -16 -130 -36 -145 -44
-51 -27 -358 -95 -477 -107 -44 -4 -136 -19 -204 -33 -68 -14 -141 -26 -162
-26 -21 0 -68 -6 -106 -14 -37 -8 -122 -17 -188 -21 -66 -3 -155 -13 -199 -21
-43 -8 -100 -14 -128 -14 -27 0 -79 -5 -116 -10 -81 -13 -274 -27 -522 -40
-102 -5 -225 -14 -275 -20 -121 -15 -596 -33 -885 -33 -263 -1 -564 16 -686
38 -44 8 -103 15 -130 15 -27 0 -128 16 -224 35 -96 19 -322 64 -502 99 -180
36 -338 70 -350 77 -12 6 -62 22 -110 35 -224 60 -269 73 -350 103 -202 72
-255 90 -298 100 -25 7 -65 20 -90 31 -25 10 -72 28 -105 38 -64 22 -143 51
-270 102 -44 18 -114 44 -155 57 -41 13 -97 35 -125 48 -118 56 -194 88 -250
105 -33 9 -81 28 -105 40 -31 16 -68 25 -121 28 -67 4 -84 1 -132 -21 -66 -30
-139 -95 -173 -154 -19 -31 -27 -63 -31 -117 -6 -72 -4 -77 32 -143 20 -37 49
-81 63 -96 35 -37 130 -90 208 -116 33 -11 100 -36 148 -55 49 -20 94 -36 100
-36 6 0 38 -14 70 -30 33 -17 89 -39 125 -50 36 -12 76 -27 88 -35 12 -8 43
-19 69 -25 26 -6 70 -22 99 -35 28 -14 58 -25 66 -25 8 0 25 -9 39 -20 14 -11
32 -20 41 -20 27 0 359 -113 404 -137 11 -6 47 -16 80 -23 33 -7 72 -19 87
-26 15 -8 62 -23 105 -33 88 -22 192 -52 303 -87 41 -13 134 -35 205 -49 72
-14 155 -34 185 -45 30 -11 152 -38 270 -60 118 -22 234 -45 257 -50 23 -6 63
-10 90 -10 26 0 84 -7 128 -16 44 -8 125 -20 180 -25 55 -6 138 -14 185 -19
234 -25 580 -33 878 -21 439 19 574 26 812 46 118 9 240 19 270 21 30 1 111 8
180 14 69 6 206 17 305 25 99 8 200 19 225 24 25 6 70 10 100 11 30 0 73 5 95
10 22 5 88 14 146 20 58 5 148 19 200 30 52 12 132 25 179 30 87 9 275 46 411
80 42 11 109 26 150 35 41 8 94 24 119 34 25 11 90 32 145 47 55 15 116 35
135 44 19 10 55 23 80 30 43 11 172 71 197 91 6 6 40 25 75 43 150 79 185 100
225 137 23 21 49 39 56 39 16 0 218 214 264 279 61 87 76 129 77 216 1 73 -2
86 -36 155 -30 60 -47 80 -80 101 -89 53 -188 76 -255 60z"
        />
      </g>
    </svg>
  );
};
